class e extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 4V6H22.5859L16.05 12.5356C15.398 13.1841 14.8811 13.9556 14.5292 14.8052C14.1773 15.6549 13.9974 16.5659 14 17.4856V28H16V17.4854C15.9983 16.8286 16.1268 16.1779 16.3782 15.5711C16.6296 14.9642 16.9988 14.4132 17.4644 13.95L24 7.4141V14H26V4H16Z" fill="#16191D"></path><path d="M7.41407 5.99999L6 7.41406L11.5859 13L13 11.5859L7.41407 5.99999Z" fill="#16191D"></path></svg>';
  }
}
const t = "pwc-icon-direction";
customElements.get(t) || customElements.define(t, e);
